export default class RoleCode {
  public static readonly BOD = 'BOD' // Ban giam doc - toan quyen
  public static readonly OCT = 'OCT' // Theo doi xe (TDX)
  public static readonly KTDV = 'KTDV' // Ke toan dau vao
  public static readonly KTDR = 'KTDR' // Ke toan dau ra
  public static readonly OPS_TT = 'OPS_TT' // OPS Thu tuc
  public static readonly OPS_HT = 'OPS_HT' // OPS Hien truong
  public static readonly RS = 'RS' // Dang ky
  public static readonly CUS = 'CUS' // Mo to khai
  public static readonly KTXHD = 'KTXHD' // Ke toan xuat hoa don
  public static readonly KTT = 'KTT' // Ke toan thue
}
